import { PropsWithChildren } from 'react';
import { useDisclosure } from '../../../lib/hooks';
import { AddPasswordPanelContext } from './context';
import AddPasswordPanel from './AddPasswordPanel';

const AddPasswordPanelProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const panel = useDisclosure();

  return (
    <AddPasswordPanelContext value={panel}>
      {<AddPasswordPanel isOpen={panel.isOpen} close={panel.close} />}
      {children}
    </AddPasswordPanelContext>
  );
};

export default AddPasswordPanelProvider;
